var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7127 87.1582H83.287C84.3682 87.158 85.431 86.8773 86.3713 86.3435C87.3116 85.8097 88.0974 85.0411 88.6518 84.1128C89.2062 83.1844 89.5103 82.1281 89.5343 81.0471C89.5583 79.9661 89.3015 78.8974 88.7889 77.9453L55.5038 16.1289C53.1424 11.7461 46.8573 11.7461 44.496 16.1289L11.2108 77.9453C10.6982 78.8974 10.4414 79.9661 10.4654 81.0471C10.4894 82.1281 10.7935 83.1844 11.3479 84.1128C11.9023 85.0411 12.6881 85.8097 13.6284 86.3435C14.5687 86.8773 15.6315 87.158 16.7127 87.1582V87.1582Z",
    stroke: "#F44336",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8787 38.1622L49.9998 61.9903L51.1189 38.1719C51.1258 38.0197 51.1016 37.8676 51.0478 37.725C50.9939 37.5824 50.9115 37.4523 50.8057 37.3426C50.6999 37.2329 50.5728 37.146 50.4322 37.0871C50.2916 37.0282 50.1405 36.9986 49.9881 37.0001C49.8383 37.0015 49.6904 37.033 49.553 37.0926C49.4156 37.1521 49.2915 37.2386 49.1881 37.347C49.0847 37.4553 49.004 37.5832 48.9509 37.7233C48.8978 37.8633 48.8732 38.0125 48.8787 38.1622Z",
    fill: "#F44336",
    stroke: "#F44336",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 77.5879C49.2274 77.5879 48.4722 77.3588 47.8298 76.9296C47.1874 76.5003 46.6868 75.8903 46.3911 75.1765C46.0954 74.4627 46.0181 73.6773 46.1688 72.9196C46.3195 72.1618 46.6916 71.4658 47.2379 70.9195C47.7842 70.3732 48.4802 70.0012 49.2379 69.8505C49.9957 69.6997 50.7811 69.7771 51.4949 70.0727C52.2086 70.3684 52.8187 70.8691 53.2479 71.5114C53.6772 72.1538 53.9063 72.9091 53.9063 73.6816C53.9063 74.7176 53.4947 75.7112 52.7621 76.4438C52.0296 77.1763 51.036 77.5879 50 77.5879Z",
    fill: "#F44336"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/error-icon.dc689a2d550bc76be2cbc627a7245076.svg";
export { ForwardRef as ReactComponent };